import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfig } from 'src/app/config/config';
import { District } from 'src/app/models/district.model';

@Injectable({
  providedIn: 'root'
})
export class DistrictService {
  private pathApi = this.config.setting['pathApi'] + "district/";

  constructor(private http: HttpClient, private config: AppConfig) { }

  get(id: any): Observable<any> {
    return this.http.get(`${this.pathApi}${id}`);
  }
  
  getAll(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}getAll`, obj);
  }

  save(obj: District): Observable<any> {
    return this.http.post(`${this.pathApi}save`, obj);
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.pathApi}delete/${id}`);
  } 

  uploadFile(obj: any): Observable<any> {
    return this.http.post(`${this.pathApi}uploadFile`, obj);
  }

  getTemplate(): Observable<any>{
    return this.http.get(`${this.pathApi}getTemplate`);
  }

  getDistrictsForOptions(): Observable<any> {
    return this.http.get(`${this.pathApi}getDistrictsForOptions`);
  }

  getDistrictsForOptionsByUser(): Observable<any> {
    return this.http.get(`${this.pathApi}getDistrictsForOptionsByUser`);
  }

  getDistrictsForOptionsByRegion(regionId: number): Observable<any> {
    return this.http.get(`${this.pathApi}getDistrictsForOptionsByRegion/${regionId}`);
  }

  getDistrictsByRegionIds(ids: any): Observable<any>{    
    return this.http.get(`${this.pathApi}getDistrictsByRegionIds?ids=${ids.join('&ids=')}`);
  }

  getAllForRegion(regionId: number): Observable<any>{    
    return this.http.get(`${this.pathApi}getAllForRegion/${regionId}`);
  }

}
